<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="审批编码：" prop="approvalNumber">
            <el-input v-model="query.approvalNumber" placeholder="请输入审批编码" size="small" clearable />
          </el-form-item>
          <el-form-item label="申请人信息：" prop="applyInfo">
            <el-input v-model="query.applyInfo" placeholder="请输入姓名/手机号" size="small" clearable />
          </el-form-item>
          <el-form-item label="子账号：" prop="customerKeywords">
            <el-input v-model="query.customerKeywords" placeholder="请输入姓名/手机号" size="small" clearable />
          </el-form-item>
          <!-- <el-form-item label="申请人身份：">
            <el-select v-model="query.applyLevel" placeholder="请选择" clearable size="small">
             <el-option :label="item.value" :value="item.key" v-for="item in sectionList" :key="item.key"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="时间筛选：">
            <el-select v-model="query.timeType" placeholder="请选择时间类型" size="small">
              <el-option label="提交时间" :value="1"></el-option>
              <el-option label="同意时间" :value="2"></el-option>
              <el-option label="驳回时间" :value="3"></el-option>
            </el-select>
            <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"
              :start-placeholder="timeTypeLabel + '起始'" :end-placeholder="timeTypeLabel + '截止'"></el-date-picker>
          </el-form-item>
          <el-form-item class="fr">
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <el-tabs v-model="activeName" @tab-click="doQueryList({pageNo:1})">
          <el-tab-pane label="待审核" name="1"></el-tab-pane>
          <el-tab-pane label="审核中" name="5"></el-tab-pane>
          <el-tab-pane label="同意申请" name="2"></el-tab-pane>
          <el-tab-pane label="驳回申请" name="3"></el-tab-pane>
        </el-tabs>
        <!-- <div class="btn-box">
          <el-button type="primary" size="mini" @click="handleDownload" plain>导出</el-button>
        </div> -->
      </div>
      <el-table v-loading="listLoading" :data="list" :key="activeName">
        <el-table-column label="审批编号" prop="approvalNumber" align="center" fixed/>
        <el-table-column label="申请人信息" prop="" align="center" fixed>
          <template slot-scope="{row}">
              <div >
                {{row.submitName}}{{row.submitPho}}
              </div>
            </template>
          </el-table-column>
        <el-table-column label="申请人身份" prop="submitLevelName" align="center"/>
        <el-table-column label="申请内容" prop="userPho" align="center" fixed>
          <template slot-scope="{row}">
              <div>{{row.customerName}}{{row.customerPho}}</div>
              <div>{{row.useModel | setModel}}</div>
            </template>
        </el-table-column>
        <el-table-column label="提交时间" prop="submitTime" sortable align="center" width="200"/>
        <el-table-column v-if="activeName === '2' || activeName === '3'" :label="activeName === '2' ? '同意时间' : '驳回时间'" prop="auditTime" sortable align="center" width="200"/>
        <!-- <el-table-column label="待审核人" prop="operatedBy" align="center" /> -->
        <!-- <el-table-column label="同意申请" prop="resignationTime" sortable align="center" width="200"/> -->
        <!-- <el-table-column label="驳回时间" prop="operatedTime" sortable align="center" width="200" />
        <el-table-column label="驳回原因" prop="operatedBy" align="center" /> -->
        <el-table-column label="操作" align="center" fixed="right" width="160">
          <template slot-scope="{row}"  >
            <el-button type="text" @click="handleCreate(1,row)">审批流程</el-button>
          </template>
        </el-table-column>
      </el-table>

      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize"
        @pagination="doQueryList" />
    </el-card>
    <!-- 新建表单 -->
    <city-add ref="cityAdd" @created="doQueryList({})" :popType="popType"/>
  </div>
</template>

<script>
  import businessProcessingApi from '@/api/user/businessProcessing'
  import sysDeptApi from '@/api/sys/sysDept'
  import Pagination from '@/components/Pagination'
  import userApi from '@/api/sys/user'
  import cityAdd from './add'
  // import customerLevelApi from '@/api/sys/customerLevel'
  export default {
    components: {
      Pagination,
      cityAdd
      // businessQuit,
      // businessAdjust,
      // areaRemove
    },
    filters:{
      setModel(val){
        if(!val) return
        let arr=val.split('#').filter(i=>i)
        arr=arr.map(i=>{
          if(i==1){
            i='学习模块'
          }
          if(i==2){
            i='订货模块'
          }
          return i
        })
        // console.log('arr: ',arr);
        return arr.join('、')
      }
    },
    data() {
      return {
        popType:null,
        list: [],
        total: 0,
        listLoading: true,
        query: {
          pageNo: 1,
          pageSize: 10,
          timeType: 1,
        },
        sectionList: [],
        dateTime: null,
        activeName:'1'
      }
    },
    computed: {
      timeTypeLabel() {
        return { 1: '提交时间', 2: '同意时间', 3: '驳回时间' }[this.query.timeType]
      }
    },
    created() {
      this.doQueryList({
        pageNo: 1
      })
      // this.getOption()
    },
    methods: {
      handleFilter() {
        this.query = {
          pageNo: 1,
          pageSize: 10,
          timeType: 1,
        }
        this.dateTime=[]
        this.doQueryList({
          pageNo: 1
        })
      },
      /**
       * 触发搜索操作
       */
      handleQuery() {
        this.doQueryList({
          pageNo: 1
        })
      },
      /**
       * 执行列表查询
       */
      doQueryList({
        pageNo,
        pageSize
      }) {
        if (pageNo) {
          this.query.pageNo = pageNo
        }
        if (pageSize) {
          this.query.pageSize = pageSize
        }
        let query = {
          ...this.query,
        }
        query.processingStatus=this.activeName*1
        if(this.query.timeType && this.dateTime && this.dateTime.length === 2){
          query.startTime=this.dateTime[0]
          query.endTime=this.dateTime[1]
        }
        this.listLoading = true
        return businessProcessingApi.findSubAccountListPage(query)
          .then(({
            data
          }) => {
            console.log("data: ", data);
            this.list = data.list
            this.total = data.total
          })
          .finally(() => {
            this.listLoading = false
          })
      },
      /**
       * 打开新建、编辑表单
       */
      handleCreate(type,row) {
        this.popType=type
        if(!type){
          this.$refs.cityAdd.handleCreate()
        }else{
          this.$refs.cityAdd.handleUpdate(row)
        }
      },
      //查看信息
      handleShowDetail(id){
        this.$emit('handleShow', id,2)
      },
    }
  }
</script>
